import { EmbeddedStatus, Workspace } from "winslow-core";

export type User = {
  id: string;
  email: string;
  avatarURL?: string;
  firstName?: string;
  lastName?: string;
  username?: string;
  title?: string;
  notifications: boolean;
  theme: "light-mode" | "dark-mode";
  greetingPhrase: string;
  signatureBlock: string;
  lastLogin: Date;
  createdAt: Date;
  updatedAt: Date;
  workspaces: Workspace[];
  collections: Collection[];
  currentWorkspaceId: string | undefined;
};

export type LinkRecord = {
  id: string;
  workspaceId: string;
  userId: string;
  user: User;
  collectionId: string;
  collection: Collection;
  canonicalId: string;
  favicon: string | null;
  embedded: boolean;
  embeddedStatus: EmbeddedStatus;
  folderName: string | null;
  folderSlug: string | null;
  folderRootId: string | null;
  links?: Link[];
  tags?: Tag[];
  snippets?: Snippet[];
  createdAt: Date;
  updatedAt: Date;
  source: "FILE" | "LINK";
  msDriveId?: string;
  msResourceId?: string;
  tokenCount: number;
};

export type SlackWebhookConfig = {
  channel: string;
  channel_id: string;
  configuration_url: string;
  url: string;
};

export type LinkAppConfig = {
  id: string;
  displayName: string;
  logo: string;
  matchKeys: string[];
  matchExternals: string[];
};

export type Tag = {
  id: string;
  workspaceId: string;
  name: string;
  userId: string;
  user: User;
};

export type Link = {
  id?: string;
  url: string;
  title: string;
  linkRecordId: string;
  linkRecord?: LinkRecord;
  userId: string;
  user?: User;
  appId?: string;
  externalId?: string;
  thumbnailUrl?: string;
  linkInfo: LinkInfo;
  views: LinkView[];
  previewImage?: string;
  previewImageUpdatedAt?: Date;
};

export type LinkView = {
  id: string;
  linkId: string;
  link: Link;
  userId: string;
  user: User;
  viewedAt: Date;
};

export type ConnectedApp = {
  id: string;
  userId: string;
  linkedAppId: string;
  slug: Prisma.JsonValue;
  createdAt: Date;
  updatedAt: Date;
};

export enum CollectionAccessTypes {
  PRIVATE = "PRIVATE",
  RESTRICTED = "RESTRICTED",
  TEAM = "TEAM",
  PUBLIC = "PUBLIC",
}

export enum SyncProgress {
  NOT_PROCESSING = "NOT_PROCESSING",
  ERRORED = "ERRORED",
  PROCESSING = "PROCESSING",
  UP_TO_DATE = "UP_TO_DATE",
}

export type CollectionFavorite = {
  id: string;
  userId: string;
  collectionId: string;
  createdAt: Date;
  updatedAt: Date;
};
